import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "overflow-auto w-full p-5",
  style: {"height":"calc(100% - 4.3rem)"}
}
const _hoisted_2 = { class: "md:max-w-lg" }
const _hoisted_3 = { class: "flex itmes-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "flex w-60 mt-4 text-desc" }, "이메일", -1)
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = {
  class: "cs-form flex w-full",
  "data-height": "md"
}
const _hoisted_7 = {
  key: 0,
  class: "cs-feedback cs-feedback-error"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fi fi-sr-comment-exclamation" }, null, -1)
const _hoisted_9 = { class: "flex itmes-center mt-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "flex w-60 mt-4 text-desc" }, "배송 비용(원)", -1)
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = {
  class: "cs-form flex w-full",
  "data-height": "md"
}
const _hoisted_13 = { class: "flex itmes-center mt-5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "flex w-60 mt-4 text-desc" }, "도색 주의 표시글", -1)
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = { class: "cs-form w-full h-44 p-3" }
const _hoisted_17 = { class: "flex itmes-center mt-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "flex w-60 mt-1 text-desc" }, [
  /*#__PURE__*/_createTextVNode("모델 생산 가능 크기"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("(X, Y, Z mm)")
], -1)
const _hoisted_19 = { class: "flex w-full" }
const _hoisted_20 = {
  class: "cs-form flex mr-2",
  "data-height": "xs"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "m-auto" }, "x", -1)
const _hoisted_22 = {
  class: "cs-form ml-2 mr-2",
  "data-height": "xs"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "m-auto" }, "x", -1)
const _hoisted_24 = {
  class: "cs-form ml-2",
  "data-height": "xs"
}
const _hoisted_25 = { class: "flex itmes-center mt-5" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "flex w-60 mt-5 text-desc" }, "모델 부피 비율", -1)
const _hoisted_27 = { class: "w-full" }
const _hoisted_28 = {
  class: "cs-form flex w-full",
  "data-height": "md"
}
const _hoisted_29 = { class: "flex itmes-center mt-5" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "flex w-60 mt-5 text-desc" }, "모델 최소 부피", -1)
const _hoisted_31 = { class: "w-full" }
const _hoisted_32 = {
  class: "cs-form flex w-full",
  "data-height": "md"
}
const _hoisted_33 = { class: "flex itmes-center mt-5" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "flex w-60 mt-2 text-desc" }, [
  /*#__PURE__*/_createTextVNode("모델 한 방향의"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("최대 길이 (mm)")
], -1)
const _hoisted_35 = { class: "w-full" }
const _hoisted_36 = {
  class: "cs-form flex w-full",
  "data-height": "md"
}
const _hoisted_37 = { class: "mt-10 text-right" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "저장", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_button = _resolveComponent("loader-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              class: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.optionEmail) = $event)),
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onValidateEmail && _ctx.onValidateEmail(...args))),
              type: "text",
              placeholder: "이메일을 입력해주세요."
            }, null, 544), [
              [_vModelText, _ctx.optionEmail]
            ])
          ]),
          (_ctx.errMsgEmail.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", null, _toDisplayString(_ctx.errMsgEmail), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              class: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.optionShippingCost) = $event)),
              onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.optionShippingCost = _ctx.numberComma(_ctx.optionShippingCost))),
              onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onInputShipping && _ctx.onInputShipping(...args))),
              type: "text",
              placeholder: "0"
            }, null, 544), [
              [_vModelText, _ctx.optionShippingCost]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("textarea", {
              class: "w-full h-full",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.optionCautionPaint) = $event))
            }, null, 512), [
              [_vModelText, _ctx.optionCautionPaint]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              class: "",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.optionBuildSizeX) = $event)),
              type: "text",
              placeholder: "0",
              onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onInputNumber && _ctx.onInputNumber(...args))),
              onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onInputBlurNumber && _ctx.onInputBlurNumber(...args)))
            }, null, 544), [
              [_vModelText, _ctx.optionBuildSizeX]
            ])
          ]),
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              class: "",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.optionBuildSizeY) = $event)),
              type: "text",
              placeholder: "0",
              onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onInputNumber && _ctx.onInputNumber(...args))),
              onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onInputBlurNumber && _ctx.onInputBlurNumber(...args)))
            }, null, 544), [
              [_vModelText, _ctx.optionBuildSizeY]
            ])
          ]),
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              class: "",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.optionBuildSizeZ) = $event)),
              type: "text",
              placeholder: "0",
              onInput: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onInputNumber && _ctx.onInputNumber(...args))),
              onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onInputBlurNumber && _ctx.onInputBlurNumber(...args)))
            }, null, 544), [
              [_vModelText, _ctx.optionBuildSizeZ]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _withDirectives(_createElementVNode("input", {
              class: "",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.optionVolumeMultiply) = $event)),
              onInput: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onInputRatio && _ctx.onInputRatio(...args))),
              onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onInputBlurRatio && _ctx.onInputBlurRatio(...args))),
              type: "text",
              placeholder: "0"
            }, null, 544), [
              [_vModelText, _ctx.optionVolumeMultiply]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _withDirectives(_createElementVNode("input", {
              class: "",
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.optionMinVolume) = $event)),
              onInput: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onInputNumber && _ctx.onInputNumber(...args))),
              onBlur: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onInputBlurNumber && _ctx.onInputBlurNumber(...args))),
              type: "text",
              placeholder: "0"
            }, null, 544), [
              [_vModelText, _ctx.optionMinVolume]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _withDirectives(_createElementVNode("input", {
              class: "",
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.optionModelMaxSize) = $event)),
              onInput: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onInputNumber && _ctx.onInputNumber(...args))),
              onBlur: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onInputBlurNumber && _ctx.onInputBlurNumber(...args))),
              type: "text",
              placeholder: "0"
            }, null, 544), [
              [_vModelText, _ctx.optionModelMaxSize]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createVNode(_component_loader_button, {
        ref: "submit",
        class: "w-56 cs-pd-btn-lg",
        cssButton: 'cs-btn-base',
        onClick: _ctx.onSubmit
      }, {
        title: _withCtx(() => [
          _hoisted_38
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}